import { useMutation } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import API_URL from '../constants/environment';
import { Role } from './useValidateSession';

interface CreateCredentials {
  email: string;
  username: string;
  password: string;
  lastName: string;
  firstName: string;
  locationId: Array<string> | 'all';
  position: Role;
  organizationId: string;
  /** Required for employee invites; the API reads their access from it. */
  inviteId?: string;
}

interface CreateObject {
  sessionId?: string,
  firstName?: string,
  /** Employee accounts: the page to open in the customer org the session starts in. */
  landingPath?: string;
  error?: string;
  message?: string;
}

export const useSubmitAccountCreation = () => {
  const submitAccountCreation = async (credentials: CreateCredentials): Promise<AxiosResponse<CreateObject>> => {
    return axios.post(`${API_URL}/account/create`, { ...credentials });
  };

  return useMutation({
    mutationFn: submitAccountCreation,
  });
}; 